import { render, staticRenderFns } from "./OnPageSetting.vue?vue&type=template&id=2ca74ddb&scoped=true&"
import script from "./OnPageSetting.vue?vue&type=script&lang=js&"
export * from "./OnPageSetting.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ca74ddb",
  null
  
)

export default component.exports